import { jsxs as m, jsx as o } from "react/jsx-runtime";
import O from "i18next";
const q = "forma-ui__superfield-select__option", z = "forma-ui__superfield-select__optionCompany", G = "forma-ui__superfield-select__optionInn", J = "forma-ui__superfield-select__optionName", K = "forma-ui__superfield-select__optionAddress", Q = "forma-ui__superfield-select__optionBank", W = "forma-ui__superfield-select__optionBankName", X = "forma-ui__superfield-select__optionBic", i = {
  option: q,
  optionCompany: z,
  optionInn: G,
  optionName: J,
  optionAddress: K,
  optionBank: Q,
  optionBankName: W,
  optionBic: X
}, V = "300", f = {
  inn: ["301", "2003", "322", "2006", "inn"],
  ogrnip: ["321"],
  company: ["304", "305", "2001", "companyname"],
  bankName: ["313"],
  address: ["306", "307", "308", "1202", "1203", "address"],
  city: ["2005", "2011"],
  passportCode: ["111"],
  passport: ["110", "1006"],
  firstname: ["1108", "207", "204", "102", "319"],
  familyname: ["1120", "1118", "1117", "206", "203", "101", "318"],
  middlename: ["1116", "1115", "208", "205", "103", "320"],
  management: ["4291"]
}, ee = (e) => {
  var p, a, r, n, s, l, c, t, y, h, u, d, g, _, N, M, b, k, v, I, w, x, B, L, S, $, T, H, E, R, U, C, A, D, F, j, P;
  return {
    101: ((p = e.fio) == null ? void 0 : p.surname) || ((a = e.forma_fio) == null ? void 0 : a.surname) || ((n = (r = e.management) == null ? void 0 : r.name) == null ? void 0 : n.split(" ")[0]),
    102: ((s = e.fio) == null ? void 0 : s.name) || ((l = e.forma_fio) == null ? void 0 : l.name) || ((t = (c = e.management) == null ? void 0 : c.name) == null ? void 0 : t.split(" ")[1]),
    103: ((y = e.fio) == null ? void 0 : y.patronymic) || ((h = e.forma_fio) == null ? void 0 : h.patronymic) || ((d = (u = e.management) == null ? void 0 : u.name) == null ? void 0 : d.split(" ")[2]),
    301: e.inn,
    302: e.ogrn,
    304: ((g = e.name) == null ? void 0 : g.full_with_opf) || ((_ = e.name) == null ? void 0 : _.full),
    305: ((N = e.name) == null ? void 0 : N.short_with_opf) || ((M = e.name) == null ? void 0 : M.short),
    306: ((b = e.address) == null ? void 0 : b.unrestricted_value) || ((k = e.address) == null ? void 0 : k.value),
    307: ((v = e.address) == null ? void 0 : v.unrestricted_value) || ((I = e.address) == null ? void 0 : I.value),
    308: ((w = e.address) == null ? void 0 : w.unrestricted_value) || ((x = e.address) == null ? void 0 : x.value),
    318: ((B = e.fio) == null ? void 0 : B.surname) || ((S = (L = e.management) == null ? void 0 : L.name) == null ? void 0 : S.split(" ")[0]),
    319: (($ = e.fio) == null ? void 0 : $.name) || ((H = (T = e.management) == null ? void 0 : T.name) == null ? void 0 : H.split(" ")[1]),
    320: ((E = e.fio) == null ? void 0 : E.patronymic) || ((U = (R = e.management) == null ? void 0 : R.name) == null ? void 0 : U.split(" ")[2]),
    // moved from forma_lk contragents search
    // 321: data.inn.length === IP_INN_LENGTH ? data.ogrn : undefined,
    // 322: data.inn.length === IP_INN_LENGTH ? data.inn : undefined,
    321: e.ogrn,
    322: e.inn,
    316: e.okved,
    317: e.okpo,
    2006: e.inn,
    2009: e.kpp,
    4291: (A = (C = e.management) == null ? void 0 : C.post) == null ? void 0 : A.toLocaleLowerCase(),
    inn: e.inn,
    companyname: ((D = e.name) == null ? void 0 : D.full_with_opf) || ((F = e.name) == null ? void 0 : F.full),
    ogrn: e.ogrn,
    address: ((j = e.address) == null ? void 0 : j.unrestricted_value) || ((P = e.address) == null ? void 0 : P.value),
    kpp: e.kpp
  };
}, ne = (e) => ({
  311: e.correspondent_account,
  312: e.bic
}), se = (e) => ({
  110: e.value,
  111: e.id
}), ae = (e, p) => {
  const a = p;
  return ["address", "firstname", "familyname", "middlename", "city"].includes(p) ? a : f.company.includes(e) ? "companyname" : f.bankName.includes(e) ? "bankname" : f.passport.includes(e) ? "passport" : f.passportCode.includes(e) ? "passportcode" : f.city.includes(e) ? "city" : null;
}, re = (e) => {
  const { t: p } = O;
  return e === "bankname" ? {
    type: "list",
    values: [],
    loadingUrl: "/dadata/suggestbank",
    loadingMapper: (a, r) => a.map(({ data: n, value: s }) => {
      var t;
      const l = s.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>'), c = (t = n.address) == null ? void 0 : t.value;
      return {
        label: /* @__PURE__ */ m("span", { className: i.option, children: [
          /* @__PURE__ */ m("span", { className: i.optionBank, children: [
            /* @__PURE__ */ o("span", { className: i.optionBankName, dangerouslySetInnerHTML: { __html: l } }),
            /* @__PURE__ */ o("span", { className: i.optionBic, dangerouslySetInnerHTML: { __html: `${p("uikit:bic")}: ${n.bic}` } })
          ] }),
          /* @__PURE__ */ o("span", { className: i.optionAddress, children: c })
        ] }),
        value: s,
        data: n
      };
    })
  } : e === "address" ? {
    type: "list",
    values: [],
    loadingUrl: "/dadata/suggestaddress",
    loadingMapper: (a, r) => a.map(({ unrestricted_value: n, data: s }) => {
      const l = n.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>');
      return {
        label: /* @__PURE__ */ o("span", { className: i.option, children: /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: l } }) }),
        value: n,
        data: s
      };
    })
  } : e === "city" ? {
    type: "list",
    values: [],
    loadingUrl: "/dadata/cities",
    loadingMapper: (a, r) => a.map(({ title: n, region: s }) => {
      let l = n;
      return s != null && s.title && (l += `, ${s.title}`), l = l.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>'), {
        label: /* @__PURE__ */ o("span", { className: i.option, children: /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: l } }) }),
        value: n
        // data: data
      };
    })
  } : e === "passport" ? {
    type: "list",
    values: [],
    loadingMethod: "get",
    loadingUrl: "/langbase/suggestfmsunit",
    loadingMapper: (a, r) => a.map(({ id: n, value: s }) => {
      const l = n.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>');
      return {
        label: /* @__PURE__ */ m("span", { className: i.option, children: [
          /* @__PURE__ */ m("span", { className: i.optionInn, children: [
            p("uikit:code"),
            ": ",
            /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: l } })
          ] }),
          /* @__PURE__ */ o("span", { className: i.optionAddress, children: s })
        ] }),
        value: s,
        data: { id: n, value: s }
      };
    })
  } : e === "passportcode" ? {
    type: "list",
    values: [],
    loadingMethod: "get",
    loadingUrl: "/langbase/suggestfmsunit",
    loadingMapper: (a, r) => a.map(({ id: n, value: s }) => {
      const l = n.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>');
      return {
        label: /* @__PURE__ */ o("span", { className: i.option, children: /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: l } }) }),
        value: n,
        data: { id: n, value: s }
      };
    })
  } : e === "firstname" ? {
    type: "list",
    values: [],
    loadingMethod: "get",
    loadingUrl: "/langbase/suggestfio/firstname",
    loadingMapper: (a, r) => a.map((n) => {
      const s = n.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>');
      return {
        label: /* @__PURE__ */ o("span", { className: i.option, children: /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: s } }) }),
        value: n
      };
    })
  } : e === "familyname" ? {
    type: "list",
    values: [],
    loadingMethod: "get",
    loadingUrl: "/langbase/suggestfio/familyname",
    loadingMapper: (a, r) => a.map((n) => {
      const s = n.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>');
      return {
        label: /* @__PURE__ */ o("span", { className: i.option, children: /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: s } }) }),
        value: n
      };
    })
  } : e === "middlename" ? {
    type: "list",
    values: [],
    loadingMethod: "get",
    loadingUrl: "/langbase/suggestfio/middlename",
    loadingMapper: (a, r) => a.map((n) => {
      const s = n.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>');
      return {
        label: /* @__PURE__ */ o("span", { className: i.option, children: /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: s } }) }),
        value: n
      };
    })
  } : {
    type: "list",
    values: [],
    loadingUrl: "/dadata/suggestparty",
    loadingMapper: (a, r) => a.map(({ data: n, value: s, forma_fio: l }, c) => {
      var u, d, g, _;
      const t = n.inn.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>'), y = s.replace(new RegExp(r.trim(), "i"), '<span class="green">$&</span>'), h = ((d = (u = n.address) == null ? void 0 : u.data) == null ? void 0 : d.city) || ((_ = (g = n.address) == null ? void 0 : g.data) == null ? void 0 : _.settlement_with_type);
      return {
        label: /* @__PURE__ */ m("span", { className: i.option, children: [
          /* @__PURE__ */ m("span", { className: i.optionCompany, children: [
            /* @__PURE__ */ m("span", { className: i.optionInn, children: [
              p("uikit:inn"),
              ": ",
              /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: t } })
            ] }),
            /* @__PURE__ */ o("span", { className: i.optionName, dangerouslySetInnerHTML: { __html: y } })
          ] }),
          /* @__PURE__ */ o("span", { className: i.optionAddress, children: h })
        ] }),
        value: n.inn + "" + c,
        data: { ...n, forma_fio: l }
      };
    })
  };
};
export {
  ae as getSuperFieldType,
  re as getSuperFieldsProps,
  V as groupCompany,
  ne as parseBankData,
  ee as parseOrgData,
  se as parsePassportData,
  f as superFields
};
